import AuthTopPanelMain from './authTopPanelMain'
export default AuthTopPanelMain
